import Vue from "vue";
import Component from "vue-class-component";
import { IServices, IServicesListItem } from "@/entity/services/services.types";
import { ServiceStore } from "@/store/modules/Services";

@Component
export class ServicesMix extends Vue {

    get service(): IServices | null {
        return ServiceStore.service;
    }
    get services(): IServicesListItem | null {
        return ServiceStore.services;
    }
}
